import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Typography,
  Box,
  ButtonGroup,
} from "@mui/material";
import { Check } from "lucide-react";

export default function UnsavedConfigsModal({
  retrievedDataSelection,
  reflectRetrievedDataSelection,
  isNight = false,
}) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (retrievedDataSelection) {
      setOpen(true);
    }
  }, [retrievedDataSelection]);

  //   const handleRetrieve = () => {
  //     const savedConfig = localStorage.getItem("configData");
  //     if (savedConfig) {
  //       onRetrieve(JSON.parse(savedConfig));
  //     }
  //     setOpen(false);
  //   };

  //   const handleStartNew = () => {
  //     localStorage.removeItem("configData");
  //     onStartNew();
  //     setOpen(false);
  //   };

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      PaperProps={{
        sx: {
          backgroundColor: isNight ? "#3d4658" : "#fff",
          color: isNight ? "#eef2f7" : "inherit",
          transition: "color 0.35s ease, background-color 0.35s ease",
        },
      }}
    >
      <DialogTitle
        sx={{
          fontSize: "calc(0.91rem + var(--large-screen-font-bump))",
          fontWeight: "bold",
          padding: "3vh 3vh 2vh 3vh",
        }}
      >
        Unsaved Configurations Found
      </DialogTitle>
      <DialogContent sx={{ padding: "3vh 3vh" }}>
        <Typography
          sx={{
            fontSize: "calc(0.86rem + var(--large-screen-font-bump))",
          }}
        >
          We found configurations from your last visit. Would you like to
          retrieve them or start fresh?
        </Typography>
        <Box height={"3vh"}></Box>
        <ButtonGroup sx={{ float: "right" }}>
          <Button
            onClick={() => {
              setOpen(false);
            }}
            variant="outlined"
            color="primary"
            sx={{
              fontSize: "calc(0.72rem + var(--large-screen-font-bump))",
              borderRadius: "0",
              backgroundColor: "#transparent",
              color: isNight ? "#eef2f7" : "#d32f2f",
              fontWeight: "bold",
              border: "none !important;",
              marginRight: "2vh",
              transition: "color 0.35s ease",
            }}
          >
            No, Start New
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              reflectRetrievedDataSelection();
              setOpen(false);
            }}
            sx={{
              fontSize: "calc(0.72rem + var(--large-screen-font-bump))",
              borderRadius: "0",
              backgroundColor: "#d32f2f",
              fontWeight: "bold",
              border: "none !important;",
            }}
          >
            <>Yes, Retrieve</>
            <Box width={"10px"}></Box>
            <Check size={"15"}></Check>
          </Button>
        </ButtonGroup>
      </DialogContent>
    </Dialog>
  );
}
